import { render, staticRenderFns } from "./DeleteDeptDialog.vue?vue&type=template&id=520007fa&scoped=true&"
import script from "./DeleteDeptDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDeptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520007fa",
  null
  
)

export default component.exports